<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="28" height="28" rx="14" fill="#1719DA" />
    <g clip-path="url(#clip0_2271_54383)">
      <path
        d="M13.1667 7.33301H21.5V8.99967H13.1667V7.33301ZM13.1667 10.6663H18.1667V12.333H13.1667V10.6663ZM13.1667 15.6663H21.5V17.333H13.1667V15.6663ZM13.1667 18.9997H18.1667V20.6663H13.1667V18.9997ZM6.5 7.33301H11.5V12.333H6.5V7.33301ZM8.16667 8.99967V10.6663H9.83333V8.99967H8.16667ZM6.5 15.6663H11.5V20.6663H6.5V15.6663ZM8.16667 17.333V18.9997H9.83333V17.333H8.16667Z"
        fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_2271_54383">
        <rect width="20" height="20" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: ["color"]
}
</script>